import { MenuItem, TextField } from "@material-ui/core"
import type { ReactElement } from "react"

import "./language-switcher.styles.scss"
import { useTranslation } from "react-i18next"
import { i18nLanguageStorageKey } from "../../../i18n/i18nInit"
import { i18nSavedLanguageStorageKey } from "../../../i18n/i18nSavedLanguageDetector"

function LanguageSwitcherComponent(): ReactElement {
  const { i18n } = useTranslation()
  const languages = i18n.options.supportedLngs
  const selectedLanguage = i18n.language

  const handleBusinessLanguageChange = (selectedLanguage: string | null) => {
    if (!selectedLanguage) return
    if (selectedLanguage) {
      window.localStorage.setItem(i18nLanguageStorageKey, selectedLanguage)
      window.localStorage.setItem(i18nSavedLanguageStorageKey, selectedLanguage)
    } else {
      window.localStorage.removeItem(i18nLanguageStorageKey)
      window.localStorage.removeItem(i18nSavedLanguageStorageKey)
    }

    i18n.changeLanguage(selectedLanguage)
  }

  return (
    <>
      {languages && (
        <TextField
          select
          className="language-switcher-select"
          variant="outlined"
          value={selectedLanguage ? selectedLanguage : " "}
        >
          {languages.map((language: string) => (
            <MenuItem key={language} value={language} onClick={() => handleBusinessLanguageChange(language)}>
              {language}
            </MenuItem>
          ))}
        </TextField>
      )}
    </>
  )
}

export const LanguageSwitcher = LanguageSwitcherComponent
